<template>
    <biller-modal :isVisible="shouldShow">
        <div class="pt-16 px-16 md:px-24 pb-12 modal-width w-full">
            <p class="text-grey-300 text-base font-semibold text-center">Payment Failed</p>
            <p class="mt-6 text-sm text-smoke-dark w-10/12 mx-auto text-center">
                {{ message }}
            </p>
            <div class="my-12 relative h-40 flex items-center justify-center">
                <img src="@/assets/svg/failed.svg" />
            </div>
            <div class="flex flex-col items-center justify-center pt-2">
                <button
                    class="rounded-lg bg-orange-pale px-8 py-4 text-orange font-semibold text-base"
                    @click="$emit('retry')"
                >
                    Try Again
                </button>
                <div class="mt-8">
                    <button @click="$emit('go-to-dashboard')" class="text-smoke-dark text-base font-semibold">
                        Go to Dashboard
                    </button>
                </div>
            </div>
        </div>
    </biller-modal>
</template>

<script>
export default {
    props: {
        shouldShow: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
@media screen and (min-width: 640px) {
    .modal-width {
        width: 450px;
    }
}

.modal-width {
    min-width: 320px;
}
</style>
